module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj48cGF0aCBkPSJNOSAzaDE2LjVMMzQgMTEuNVYzNWEyIDIgMCAwIDEtMiAySDlhMiAyIDAgMCAxLTItMlY1YTIgMiAwIDAgMSAyLTJ6IiBmaWxsPSIjMTJCODg2Ii8+PHBhdGggZD0iTTI1LjUgM3Y2LjVhMiAyIDAgMCAwIDIgMkgzNHoiIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iLjQ1Ii8+PGNpcmNsZSBjeD0iMTUiIGN5PSIxOSIgcj0iMi42IiBmaWxsPSIjZmZmIi8+PHBhdGggZD0iTTExIDMxbDUuNS02LjUgMy41IDQgMy0zLjJMMzAgMzF6IiBmaWxsPSIjZmZmIi8+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/disk/image.svg
// module id = 1302
// module chunks = 8